'use strict';

var _slicedToArray = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var useScreenSize = function useScreenSize() {
  var _ref = (0, _react.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      isMobile = _ref2[0],
      setIsMobile = _ref2[1];

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isTablet = _ref4[0],
      setIsTablet = _ref4[1];

  var checkScreenSize = function checkScreenSize() {
    var width = window.innerWidth;
    setIsMobile(width <= 768);
    setIsTablet(width > 768 && width <= 1024);
  };

  (0, _react.useEffect)(function () {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return function () {
      return window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  return {
    isMobile: isMobile,
    isTablet: isTablet
  };
};

exports.default = useScreenSize;